import { settings } from "../settings";

const fetchWrapper = async (market) => {
  try {
    const res = await fetch(`${settings.fragmentApi}/fragment/wrapper?market=${market}`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.json();
  } catch (e) {
    console.error("Failed to load wrapper:", e);
    return {};
  }
};

const insertHtml = (id, html) => {
  const el = document.getElementById(id);
  if (el) el.innerHTML = html;
  else console.warn(`Container with id "${id}" not found.`);
};

const addTuiWrapper = async (market) => {
  const data = await fetchWrapper(market);
  insertHtml("header", data.headerHtml || "");
  insertHtml("footer", data.footerHtml || "");
};

export default addTuiWrapper;
